import React from "react";

interface IconProps {
  fill: string;
  title: string;
}

const GroupParameter: React.FC<IconProps> = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill={props.fill}>
    <title>{props.title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="group_parameter">
          <path d="M39.52,24.48h-8V12.1a8.07,8.07,0,0,1,8-8.09v8s0,0,0,.09Z" />
          <rect x="57.08" y="43.98" width="13.27" height="8" />
          <path d="M70.33,52V44s0,0,0-.09V12.1a.1.1,0,0,0,0-.09l0-8a8.07,8.07,0,0,1,8,8.09V43.89A8.07,8.07,0,0,1,70.33,52Z" />
          <rect
            x="50.93"
            y="-0.53"
            width="8"
            height="18.23"
            transform="translate(46.27 63.51) rotate(-89.92)"
          />
          <path d="M12.85,78.67a8.06,8.06,0,0,1-8-8.09V38.8a8.06,8.06,0,0,1,8-8.09v8s0,0,0,.09V70.58c0,.08,0,.1,0,.1Z" />
          <rect x="12.82" y="70.67" width="30.83" height="8" />
          <path d="M43.63,78.67v-8s0,0,0-.09V38.8a.15.15,0,0,0,0-.1l0-8a8.07,8.07,0,0,1,8,8.09V70.58A8.07,8.07,0,0,1,43.63,78.67Z" />
          <rect
            x="24.24"
            y="26.17"
            width="8"
            height="18.23"
            transform="translate(-7.08 63.47) rotate(-89.92)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default GroupParameter;
